import { IUserV2, TRealmDataType } from '../../types';

interface IParams {
  /**
   * Type of data we're going to save
   */
  type: TRealmDataType;
  /**
   * Data we're saving
   */
  data: any;
  /**
   * User object
   */
  user: IUserV2;

  // FORM
  /**
   * When we're saving forms we want to know if it's a main form in order to
   * set this flag, this is used in order to identify them for the forms index
   */
  isMainForm?: boolean;
}

/**
 * Prepare the data to be stored in the Realm database
 *
 * @param data object that will be stored
 */
const parseDataToRealm = ({
  type,
  data,
  user,
  isMainForm,
}: IParams): any | undefined => {
  let parsedData: any = {};

  if (
    data !== undefined &&
    data !== null &&
    typeof data === 'object' &&
    !Array.isArray(data)
  ) {
    if (type === 'forms') {
      parsedData['fid'] = data.id;
      parsedData['id'] = data.id;
      parsedData['userId'] = user.id;
      parsedData['version'] = data.version;
      if (isMainForm === true) {
        parsedData['isMain'] = true;
      }
      parsedData['formGizmoConfig'] = JSON.stringify(data);
    } else if (type === 'filledForms') {
      parsedData['id'] = data.id;
      parsedData['userId'] = user.id;
      parsedData['fid'] = data.filledFormId;
      parsedData['formId'] = data.formId;
      parsedData['formVersion'] = data.formVersion;
      parsedData['version'] = data.version;
      parsedData['savedAt'] = data.epoch_end;

      // Offline flags
      parsedData['uploaded'] = data.uploaded || false;
      parsedData['draft'] = data.draft || false;
      parsedData['updated'] = data.updated || false;
      parsedData['downloaded'] = data.downloaded || false;
      parsedData['downloadedByConfig'] = data.downloadedByConfig || false;

      if (data.offlineStatus) {
        parsedData['offlineStatus'] = data.offlineStatus;
      } else {
        // If the filled form has no offline status when being saved we set it
        // to 'saved'
        parsedData['offlineStatus'] = 'newSaved';
      }
      parsedData['gizmoData'] = JSON.stringify(data);
    } else if (type === 'userEvents') {
      parsedData['fid'] = data.fid;
      parsedData['userId'] = user.id;
      parsedData['category'] = data.category;
      parsedData['type'] = data.type;
      parsedData['timestamp'] = data.timestamp;
      parsedData['timezone'] = data.timezone;
      parsedData['uploaded'] = data.uploaded;
      if (data.data) {
        parsedData['data'] = JSON.stringify(data.data);
      }
    } else if (type === 'globals') {
      parsedData['fid'] = data.fid;
      if (data.data) {
        parsedData['data'] = JSON.stringify(data.data);
      }
    } else if (type === 'attachments') {
      parsedData = data;
    } else if (type === 'catalogOptions') {
      parsedData['fid'] = data.fid;
      parsedData['value'] = data.value;
      parsedData['selected'] = data.selected;
      parsedData['parentFid'] = data.parentFid;
      parsedData['catalogFid'] = data.catalogFid;
      if (data.extraData) {
        parsedData['extraData'] = JSON.stringify(data.extraData);
      }
    } else if (type === 'locations') {
      parsedData['fid'] = data.fid;
      parsedData['data'] = JSON.stringify(data);
    }

    return parsedData;
  } else {
    return;
  }
};

export default parseDataToRealm;
